import { render, staticRenderFns } from "./PaymentNewVDCardDialog.vue?vue&type=template&id=de3ddb38&scoped=true"
import script from "./PaymentNewVDCardDialog.vue?vue&type=script&lang=ts"
export * from "./PaymentNewVDCardDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3ddb38",
  null
  
)

export default component.exports